export const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});



// WEBPACK FOOTER //
// ./src/utils/objects.js